import { forwardRef } from "react";
import { bool, number, string, node, func, oneOfType, arrayOf } from "prop-types";
import { observer } from "mobx-react"
import { useEstimateEditorStore } from "@tools";
import { Button } from "@components";
import Grid from "@material-ui/core/Grid";
import { ExpandMore } from "@material-ui/icons";
import useStyle from "@tools/EstimateEditor/styles/CommonTableStyles.style";
import classnames from "classnames";

export const TableTitle = observer(forwardRef(({
  id,
  title,
  showContent,
  expandable,
  onContentAction,
  children,
  action,
  className,
  presetClass,
  buttonPresetClass,
  disabled,
}, ref) => {
  const classes = useStyle();
  const { presetEditionMode } = useEstimateEditorStore()
  
  return (
    <Grid
      data-id={id}
      item
      container
      justifyContent="space-between"
      alignItems="center"
      className={classnames("tableTitleContainer", classes.tableTitle, className)}
      ref={ref}
      name={`table_${title.toLowerCase().replace(/ /g, "_")}`}
    >
      <Grid
        item container
        alignItems="center"
        className={classnames("w-max", disabled && "transparent-2")}
      >
        {
          (expandable || presetEditionMode) &&
          <Button
            color="secondary"
            size="small"
            variant="contained"
            className={classnames("expand", classes.tableTitleExpandButton, buttonPresetClass)}
            onClick={onContentAction}
            name={showContent ? "Collapse table" : "Expand table"}
            icon={
              <ExpandMore
                className={classnames(" transition", showContent ? "-rotate-90" : "rotate-0")}
              />
            }
          />
        }
        <h3 className={`preset-${presetClass}Header pt-${presetClass}`}>
          {title}
        </h3>
        {action}
      </Grid>
      {children}
    </Grid>
  );
}));

TableTitle.propTypes = {
  id: oneOfType([string, number]).isRequired,
  title: string.isRequired,
  presetClass: string.isRequired,
  buttonPresetClass: string,
  className: string,
  children: oneOfType([arrayOf(node), node]),
  showContent: bool,
  onContentAction: func,
  action: node,
  expandable: bool,
  disabled: bool,
};
